const state = {
  dataToCache: {
    activeName: null,
    tabSubscribers: null,
  },
};

const mutations = {
  setKeyDataToCache(state, data) {
    state.dataToCache[data.key] = data.value;
  },
  setActiveName(state, name) {
    state.dataToCache.activeName = name;
  },
  setTabSubscribers(state, tab) {
    state.dataToCache.tabSubscribers = tab;
  },
};

const actions = {};

const getters = {
  dataToCache(state) {
    return state.dataToCache;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
